import { IconDefinition } from "./types";

const chevronDown: IconDefinition = {
  iconName: "chevron-down",
  width: 512,
  height: 512,
  svgPathData:
    "M256.4 425.9l17-17 200-200 17-17-33.9-33.9-17 17-183 183-183-183-17-17-33.9 33.9 17 17 200 200 17 17z",
  iconType: "fill",
  fontAwesomeName: "chevron-down",
  unicode: 0xf078,
};

export { chevronDown };
